
import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './auth';
import { dossieReducer } from './dossie';
import { loadingReducer } from './loading';
import { modalContainerReducer } from './modal-container';
import { navigationReducer } from './navigation';
import { toastAlertReducer } from './toast-alert';
export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    navigation: navigationReducer,
    modalContainer: modalContainerReducer,
    toastAlert: toastAlertReducer,
    dossie: dossieReducer
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;